import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { useParams, useNavigate } from 'react-router-dom';
import { RouteMap } from '@/routes/Routes';
import { LeftSide, SettingBox, Subtitle, WhiteWrapper } from '../PlanAndPayments/components/styles';
import { useAuthStore } from '@/stores/authStore';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);
// Silence unhandled rejection when js.stripe.com is blocked (ad blockers, flaky networks).
// Stripe Elements still renders its own error state via stripePromise.
stripePromise.catch(() => {});

const CheckoutForm = () => {
  const { customerSecret } = useParams();
  const navigate = useNavigate();
  // Use customerSecret directly - no need for separate state
  const clientSecret = customerSecret ?? null;
  const { fetchAndSetUserData } = useAuthStore();

  // Redirect if no customer secret provided
  useEffect(() => {
    if (customerSecret === undefined) {
      navigate(RouteMap.PLAN);
    }
  }, [customerSecret, navigate]);

  // Early return: don't render checkout if customerSecret is undefined
  if (customerSecret === undefined) {
    return null;
  }

  const handleOnComplete = async () => {
    await fetchAndSetUserData({ force: true });
    navigate(RouteMap.PLAN);
  };

  return (
    <Box p={4}>
      <SettingBox>
        <LeftSide>
          <Typography variant="body1" fontWeight="700">
            Payment Management
          </Typography>
          <Subtitle variant="body2">You can upgrade your account here</Subtitle>
        </LeftSide>
        <WhiteWrapper>
          <EmbeddedCheckoutProvider
            stripe={stripePromise}
            options={{
              clientSecret,
              onComplete: handleOnComplete,
            }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </WhiteWrapper>
      </SettingBox>
    </Box>
  );
};

export default CheckoutForm;
